import React, { createContext,useEffect,useState } from "react";
import  {TrendingCoins} from '../../config/CoinAPI';
import axios from "axios";
import { notification } from "antd";
import toast from "react-hot-toast";


import coinGecko from "../CryptoTrack/api/coinGecko";

export const TrendingContext=createContext();

export default function TrendingContextProvider({children}){

    // console.log("initialid      ",initialid);
        const [trending, setTrending] = useState([]);
        // const [currency, setCurrency] = useState('usd');

        // const handleCurrencyChange = (value) => {
        //   setCurrency(value);
        // };
      
        const fetchTrendingCoins = async () => {
          try{
          const { data } = await axios.get(TrendingCoins());
          console.log(data);
          setTrending(data);
          }
          catch(error){
            console.log(error);
          }
        };
        useEffect(()=>{
            fetchTrendingCoins();
        },[])
    //-----------------------------for Trending news-------------------------------

  const API_KEY = process.env.REACT_APP_NEWS_API;
  const url = "https://newsapi.org/v2/everything?q=";

  const [articles, setArticles] = useState([]);
  const [loading, setloading] = useState('false');
  const [query, setQuery] = useState('Cryptocurrency');
  

  async function fetchNews(query) {

    setloading(true);
    window.onoffline = (event) => {
      toast.error(`The network connection has been lost`);
    };
    try {
      const res = await fetch(`${url}${query}&apiKey=${API_KEY}`);
      const data = await res.json();
      setArticles(data.articles);
      // console.log('Apinews',API_KEY);
      console.log('TrendingData is coming before:', data);
    }
    catch (e) {
      toast.error(e.message);
      setArticles([]);
      setQuery('Cryptocurrency')
    }
    setloading(false);
    // console.log("data is:"+articles);
  }
  // useEffect(() => {
  //   setloading('true')
  //   fetchNews(query);
  //   setloading('false');
  // }, [query]);
   

    // ----------------------------for history chart--------------------------------
//   const [coinData, setCoinData] = useState({});
//   const [isLoading, setIsLoading] = useState(false);

//   const formatData = (data) => {
//     return data.map((el) => {
//       return {
//         t: el[0],
//         y: el[1].toFixed(2),
//       };
//     });
//   };

//   const fetchData = async (id) => {
//     setIsLoading(true);
//     try {
//       const [day, week, year, detail] = await Promise.all([
//         coinGecko.get(`/coins/${id}/market_chart/`, {
//           params: {
//             vs_currency: "usd",
//             days: "1",
//           },
//         }),
//         coinGecko.get(`/coins/${id}/market_chart/`, {
//           params: {
//             vs_currency: "usd",
//             days: "7",
//           },
//         }),
//         coinGecko.get(`/coins/${id}/market_chart/`, {
//           params: {
//             vs_currency: "usd",
//             days: "365",
//           },
//         }),
//         coinGecko.get("/coins/markets/", {
//           params: {
//             vs_currency: "usd",
//             ids: id,
//           },
//         }),
//       ]);

//       setCoinData({
//         day: formatData(day.data.prices),
//         week: formatData(week.data.prices),
//         year: formatData(year.data.prices),
//         detail: detail.data[0],
//       });
//       console.log("coindetailpagedata: ", coinData);
//       console.log("dayData:",day);
//       console.log("yearData:",year);
//       console.log("weekData:",week);
//       console.log("detailData:",detail);
//     }
//     catch(error){
//     //   notification.error({
//     //     message: 'Network error',
//     //     description: error,
//     //     placement: 'bottomLeft',
//     //   });
//       console.log("Error Fetching Data", error);
//       // return;
//     }
//     finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     if(initialid)
//     fetchData(initialid);
//   }, [initialid]);

            
    const values={
        trending,
        // setCurrency,
        // currency,
        // handleCurrencyChange,
        loading,
        articles,
        query,
        setQuery,
        setloading,
        fetchNews,
        // fetchData,
        // coinData, 
        // isLoading,
    };
    return <TrendingContext.Provider value={values}>
        {children}
    </TrendingContext.Provider>
}
